export default "__VITE_ASSET__C2v_gbu$__"